// eslint-disable-next-line import/prefer-default-export
export const convertNumberToLocaleString = (value) => {
  return new Intl.NumberFormat('ru', {
    minimumFractionDigits: 2,
  }).format(value)
}
